import { render } from "./vehicleprofile.vue?vue&type=template&id=0bf7ba87"
import script from "./vehicleprofile.vue?vue&type=script&lang=js"
export * from "./vehicleprofile.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__